<div class="col-lg-12 p-0 float-right">
  <div class="border upload-files float-right rounded">
    @if (draftOrder?.cartAttachment) {
      <label class="m-0 float-left">
        <a (click)="openModal()" class="font-color-knbr-primary download-links float-left font-sm-size">
          {{ draftOrder.cartAttachment }}
        </a>
      </label>
      @if (draftOrder && !isDisabled()) {
        <button
          class="btn float-left mr-1 text-dark font-size-17 color-white h-auto hover-link rounded-0 border-0"
          (click)="removeFile()"
          >
          <i class="far fa-trash-alt"></i>
        </button>
      }
    }
    @if (draftOrder && !isDisabled()) {
      @if (!draftOrder?.cartAttachment) {
        <file-upload
          simple
          [control]="fileUploadControl"
          [accept]="documentTypes"
          class="d-inline-flex border-0"
          placement="left"
          [ngbTooltip]="attachmentMissing"
          [autoClose]="false"
          triggers="manual"
          #tooltip="ngbTooltip"
          >
          <ng-template let-file #placeholder> </ng-template>
          <ng-template let-control="control" #button>
            <i
              class="fas fa-paperclip btn text-dark font-size-17 color-white h-auto hover-link rounded-0"
              aria-hidden="true"
            ></i>
          </ng-template>
        </file-upload>
      }
      <ng-template #attachmentMissing>{{ 'toolTip.attachment' | cxTranslate }}</ng-template>
      @if (draftOrder?.cartAttachment) {
        <button
          class="btn float-left text-dark font-size-17 color-white h-auto hover-link rounded-0 border-0"
          (click)="onSubmit()"
          >
          <i class="fas fa-paperclip"></i>
        </button>
      }
    }
  </div>
</div>
